exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add-profile .form-control {\n  width: 100%; }\n\n.form-group {\n  margin-bottom: 12px; }\n\n#add-profile .keyboard-center .keyboard-container {\n  padding-top: 10px; }\n\n.keyboard-center {\n  height: 460px; }\n\n.error {\n  padding: 10px;\n  width: 100%;\n  text-align: center;\n  font-size: 18px;\n  color: #ffffff;\n  background-color: #dc3545; }\n\n.account-modal-background {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 9999; }\n  .account-modal-background .message-modal {\n    font-size: 2vh;\n    background-color: #ffffff;\n    width: 525px;\n    margin-left: -250px;\n    position: absolute;\n    top: 25%;\n    left: 50%;\n    padding: 30px;\n    border-radius: 40px;\n    border: 8px solid #240A2D;\n    box-shadow: 0px 0px 0px 8px rgba(0, 0, 0, 0.2);\n    min-height: 300px;\n    z-index: 9999;\n    color: #333333; }\n    .account-modal-background .message-modal .close-modal {\n      position: absolute;\n      right: 25px;\n      top: 11px;\n      font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/routes/addprofile/addprofile.component.scss
// module id = ../../../../../src/app/routes/addprofile/addprofile.component.scss
// module chunks = main